<template>
  <div class="shenyunjie-chart-battery" :id="id"></div>
</template>

<script>
import * as echarts from "echarts";
import merge from "deepmerge";

export default {
  name: "YunJieChartBattery",
  props: {
    id: {
      type: String,
      default: function () {
        return new Date().getTime() + "-" + Math.ceil(Math.random() * 1000);
      }
    },
    loadChart: {
      type: Boolean,
      default: true
    },
    theme: {
      type: String,
      default: ""
    },
    title: {
      type: String,
      default: ""
    },
    value: {
      type: Number,
      default: 0
    },
    pattern: {
      type: Number,
      default: 0
    },
    tooltip: {
      type: Boolean,
      default: true
    },
    option: {
      type: Object,
      default: function () {
        return {}
      }
    },
    updateOption: {
      type: Function,
      default: null
    }
  },
  components: {},
  data() {
    return {
      chart: null,
      resizeObserver: null
    };
  },
  mounted() {
    let self = this;
    // 窗口大小变化监听
    window.addEventListener("resize", self.resizeBattery);
    // 元素大小变化监听
    self.resizeObserver = new ResizeObserver((entries) => {
      if (self.chart) {
        self.chart.dispose();
        this.chart = null;
      }
      self.init();
    });
    self.resizeObserver.observe(document.getElementById(self.id));
    if (self.loadChart) {
      self.init();
    }
  },
  methods: {
    resizeBattery() {
      let self = this;
      if (self.chart) {
        self.chart.resize();
      }
    },
    init() {
      let self = this;
      // 页面已存在
      if (document.getElementById(self.id) && document.getElementById(self.id).offsetHeight > 0) {
        // 初始化
        let theme = self.theme || (this.$YunJie || {}).theme || "standard";
        if (!self.chart) {
          if (theme == "darkness") {
            self.chart = echarts.init(document.getElementById(self.id), "dark");
          } else {
            self.chart = echarts.init(document.getElementById(self.id));
          }
        }
        let opt = self.getOptions(theme);
        // 合并自定义配置
        opt = merge(opt, self.option);
        // 用户自定义属性
        if (self.updateOption) {
          opt = self.updateOption(opt);
        }
        self.chart.setOption(opt, true);
        self.chart.resize();
      }
    },
    getOptions(theme) {
      let self = this;
      // 配置汇总
      let parameter = {};
      switch (self.pattern) {
        case 2:
          parameter = self.getPattern2(theme);
          break;
        case 3:
          parameter = self.getPattern3(theme);
          break;
        default:
          parameter = self.getPattern1(theme);
          break;
      }
      return parameter;
    },
    getPattern1(theme) {
      let self = this;
      // 配置汇总
      let parameter = {
        grid: {
          top: 0,
          bottom: 0,
          left: self.title ? (self.title.length * 12 + 16) : 16,
          right: self.tooltip ? 52 : 16
        },
        xAxis: {
          max: 100,
          show: false
        },
        yAxis: {
          data: [self.title],
          axisTick: {
            show: false
          },
          axisLine: {
            show: false
          }
        },
        series: [{
          name: "电量",
          type: "pictorialBar",
          symbol: "image://data:image/png;base64,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",
          symbolClip: true,
          symbolBoundingData: 100,
          data: [Math.max(Math.min(self.value, 100), 0)],
          barWidth: 18,
          label: {
            show: self.tooltip,
            formatter: function (params) {
              return `${self.value}%`;
            },
            position: "right"
          }
        }, {
          name: "外框",
          type: "bar",
          data: [100],
          barWidth: 24,
          z: 0,
          itemStyle: {
            color: theme == "darkness" ? "#777777" : "#131a27",
            borderColor: "#c7cad0",
            borderWidth: 2
          }
        }, {
          name: "面板",
          type: "bar",
          data: [100],
          barWidth: 24,
          barGap: "-100%",
          z: 2,
          itemStyle: {
            color: "transparent",
            borderColor: "#c7cad0",
            borderWidth: 2
          }
        }]
      };
      return parameter;
    },
    getPattern2(theme) {
      let self = this;
      // 配置汇总
      let parameter = {
        grid: {
          top: 0,
          bottom: 0,
          left: 8,
          right: 8
        },
        xAxis: {
          max: 100,
          show: false
        },
        yAxis: [{
          data: [self.title],
          axisLabel: {
            padding: [0, 0, 20, -8],
            inside: true,
            formatter: "{value}\n{a|占位}",
            rich: {
              a: {
                color: "transparent",
                lineHeight: 16
              }
            }
          },
          axisTick: {
            show: false
          },
          axisLine: {
            show: false
          }
        }, {
          data: [Math.max(Math.min(self.value, 100), 0)],
          show: self.tooltip,
          axisLabel: {
            padding: [0, -8, 20, 0],
            inside: true,
            formatter: function (params) {
              return `${self.value}%\n{a|占位}`;
            },
            rich: {
              a: {
                color: "transparent",
                lineHeight: 16
              }
            }
          },
          axisTick: {
            show: false
          },
          axisLine: {
            show: false
          }
        }],
        series: [{
          name: "电量",
          type: "bar",
          data: [Math.max(Math.min(self.value, 100), 0)],
          itemStyle: {
            borderRadius: 0,
            color: {
              colorStops: [{
                offset: 0,
                color: "#46B7ED"
              }, {
                offset: 1,
                color: "#48EDD3"
              }]
            }
          },
          barWidth: 24,
          z: 0
        }, {
          name: "分隔",
          type: "pictorialBar",
          symbolRotate: "-25",
          itemStyle: {
            color: "rgba(1, 12, 38, 0.4)"
          },
          symbolRepeat: "fixed",
          symbolMargin: 6,
          symbol: "rect",
          symbolClip: true,
          symbolSize: [5, 24],
          symbolPosition: "start",
          data: [Math.max(Math.min(self.value, 100), 0)],
          animationEasing: "elasticOut",
          z: 1
        }, {
          name: "外框",
          type: "bar",
          data: [100],
          barWidth: 24,
          barGap: "-100%",
          itemStyle: {
            color: "rgba(5, 59, 113, 1)",
            borderRadius: 0,
            borderColor: "#10C2E8",
            borderWidth: 2
          },
          z: -1
        }, {
          name: "面板",
          type: "bar",
          data: [100],
          barWidth: 24,
          barGap: "-100%",
          itemStyle: {
            color: "transparent",
            borderRadius: 0,
            borderColor: "#10C2E8",
            borderWidth: 2
          },
          z: 2
        }]
      };
      return parameter;
    },
    getPattern3(theme) {
      let self = this;
      // 配置汇总
      let parameter = {
        grid: {
          top: self.tooltip ? 42 : 24,
          bottom: self.title ? 56 : 40,
          left: 0,
          right: 0
        },
        xAxis: {
          type: "category",
          data: [self.title],
          axisTick: {
            show: false,
            alignWithLabel: true
          },
          axisLine: {
            show: false
          },
          axisLabel: {
            margin: 30
          }
        },
        yAxis: {
          type: "value",
          max: 100,
          show: false
        },
        series: [{
          name: "顶部",
          type: "pictorialBar",
          data: [Math.max(Math.min(self.value, 100), 0)],
          symbolSize: [40, 10],
          symbolOffset: [0, -6],
          symbolPosition: "end",
          color: "#2DB1EF",
          label: {
            show: self.tooltip,
            position: "top",
            fontSize: 15,
            fontWeight: "bold",
            color: "#34DCFF",
            formatter: function (params) {
              return `${self.value}%`;
            }
          },
          z: 12
        }, {
          name: "底部",
          type: "pictorialBar",
          data: [Math.max(Math.min(self.value, 100), 0)],
          symbolSize: [40, 10],
          symbolOffset: [0, 7],
          color: "#2DB1EF",
          z: 12
        }, {
          name: "底部圈",
          type: "pictorialBar",
          data: [Math.max(Math.min(self.value, 100), 0)],
          symbolSize: [50, 15],
          symbolOffset: [0, 12],
          itemStyle: {
            color: "transparent",
            borderColor: "#2EA9E5",
            borderType: "solid",
            borderWidth: 4
          },
          z: 10
        }, {
          name: "底部外圈",
          type: "pictorialBar",
          data: [Math.max(Math.min(self.value, 100), 0)],
          symbolSize: [70, 20],
          symbolOffset: [0, 18],
          itemStyle: {
            color: "transparent",
            borderColor: "#19465D",
            borderType: "solid",
            borderWidth: theme == "darkness" ? 8 : 4
          },
          z: 10
        }, {
          name: "高度",
          type: "bar",
          data: [Math.max(Math.min(self.value, 100), 0)],
          barWidth: 40,
          barGap: "10%",
          barCateGoryGap: "10%",
          itemStyle: {
            color: echarts.graphic.LinearGradient(0, 0, 0, 0.7, [{
              offset: 0,
              color: "#38B2E6"
            }, {
              offset: 1,
              color: theme == "darkness" ? "#0B3147" : "#ABE0F9"
            }]),
            opacity: 0.8
          }
        }]
      };
      return parameter;
    }
  },
  destroyed() {
    window.removeEventListener("resize", this.resizeBattery);
    this.resizeObserver.disconnect();
  },
  watch: {
    theme() {
      // 销毁已有曲线
      if (this.chart) {
        this.chart.dispose();
        this.chart = null;
      }
      this.init();
    },
    title() {
      this.init();
    },
    value() {
      this.init();
    },
    pattern() {
      this.init();
    },
    tooltip() {
      this.init();
    },
    option: {
      deep: true,
      handler(option) {
        this.init();
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.shenyunjie-chart-battery {
  height: 100%;
  width: 100%;
}
</style>


// WEBPACK FOOTER //
// src/components/charts/battery.vue